// extracted by mini-css-extract-plugin
export default {"row":"ProductsDashboard_row__7gh3m","col":"ProductsDashboard_col__KAXXg","card":"ProductsDashboard_card__1yG-3","container":"ProductsDashboard_container__F32HG"};